import React from 'react'
import { Grid } from 'components/Layout'
import { SPACE } from 'Theme'
import { ConsultationsChartWidget } from './ConsultationsChartWidget'
import { RevenueChartWidget } from './RevenueChartWidget'
import { TestimonialsWidget } from './TestimonialsWidget'
import { UpcomingSessionsWidget } from './UpcomingSessionsWidget'

export const ConsultationsTabContent = () => (
  <Grid
    gridTemplateColumns={{ MOBILE: '1fr', DESKTOP: '1fr 1fr' }}
    gridTemplateRows="auto"
    gridGap={SPACE.PX_20}
  >
    <UpcomingSessionsWidget />
    <RevenueChartWidget />
    <TestimonialsWidget />
    <ConsultationsChartWidget />
  </Grid>
)
